import {
  db,
  doc,
  getDoc,
  listPathAssignments,
  loadLearningPath,
} from "./firebase";
import { resolvePathProgress } from "./learningPath";

async function fetchJuniorData(uid) {
  if (!db) return { userProgress: null, labProgress: null, skills: null, userDoc: null };
  const [upSnap, lpSnap, skSnap, uSnap] = await Promise.all([
    getDoc(doc(db, "user_progress", uid)),
    getDoc(doc(db, "labProgress", uid)),
    getDoc(doc(db, "skills", uid)),
    getDoc(doc(db, "users", uid)),
  ]);
  return {
    userProgress: upSnap.exists() ? upSnap.data() : null,
    labProgress: lpSnap.exists() ? lpSnap.data() : null,
    skills: skSnap.exists() ? skSnap.data() : null,
    userDoc: uSnap.exists() ? uSnap.data() : null,
  };
}

function deriveDisplayName(userDoc, uid) {
  if (userDoc) {
    if (userDoc.displayName) return userDoc.displayName;
    if (userDoc.email) return userDoc.email.split("@")[0];
  }
  return uid;
}

function deriveCurrentLevelTitle(progress) {
  if (!progress || !Array.isArray(progress.levels) || progress.levels.length === 0) return "";
  if (progress.complete) return progress.levels[progress.levels.length - 1].title;
  const idx = progress.levels.findIndex(
    (_, i) => !progress.completedLevelIndexes.includes(i),
  );
  return idx >= 0 ? progress.levels[idx].title : progress.levels[progress.levels.length - 1].title;
}

async function loadJuniorRoster() {
  const assignments = await listPathAssignments();

  const pathCache = {};
  const loadPath = async (pathId) => {
    if (pathId in pathCache) return pathCache[pathId];
    const def = await loadLearningPath(pathId);
    pathCache[pathId] = def;
    return def;
  };

  const todayKey = new Date().toISOString().slice(0, 10);

  const rows = await Promise.all(
    assignments.map(async (a) => {
      try {
        const [pathDef, junior] = await Promise.all([
          loadPath(a.pathId),
          fetchJuniorData(a.uid),
        ]);

        const up = junior.userProgress;
        const sources = {
          labProgress: junior.labProgress,
          completedModuleIds: (up && up.completedModuleIds) || [],
          certProofs: junior.skills ? junior.skills.proofs : null,
        };
        const progress = pathDef ? resolvePathProgress(pathDef, sources) : null;

        const mentorQsToday =
          (up && up.perDay && up.perDay[todayKey] && up.perDay[todayKey]["mentor.question_asked"]) || 0;
        const mentorQsTotal = (up && up.mentorQuestions) || 0;

        const userDoc = junior.userDoc;
        return {
          uid: a.uid,
          displayName: deriveDisplayName(userDoc, a.uid),
          email: (userDoc && userDoc.email) || "",
          pathId: a.pathId,
          pathTitle: pathDef ? pathDef.title : a.pathId,
          pct: progress ? progress.pct : 0,
          currentLevelTitle: deriveCurrentLevelTitle(progress),
          xp: (up && up.xp) || 0,
          level: (up && up.level) || 0,
          streakDays: (up && up.streakDays) || 0,
          mentorQsToday,
          mentorQsTotal,
          nextCheckinAt: (a.checkin && a.checkin.nextCheckinAt) || null,
        };
      } catch (_err) {
        return {
          uid: a.uid,
          displayName: a.uid,
          email: "",
          pathId: a.pathId || "",
          pathTitle: a.pathId || "",
          pct: 0,
          currentLevelTitle: "",
          xp: 0,
          level: 0,
          streakDays: 0,
          mentorQsToday: 0,
          mentorQsTotal: 0,
          nextCheckinAt: null,
        };
      }
    }),
  );

  return rows;
}

export { loadJuniorRoster };
